import Swiper from 'swiper';
import {Autoplay, Navigation} from 'swiper/modules';
import {getOptionsFromJsonString} from "cronus-theme/default/global/js/utilities/options";

export function initSlideshows(query = document.querySelectorAll('.dcSlideshow.swiper')) {
    for (const slideshow of query) {
        Swiper.use([Autoplay, Navigation]);
        const options = getOptionsFromJsonString(slideshow.dataset.options, {
            autoplay_interval: 5000,
            eff_interval: 300,
        });
        new Swiper(slideshow, {
            loop: true,
            items: 1,
            speed: options.eff_interval,
            autoplay: options.autoplay_interval > 0
                ? { delay: options.autoplay_interval }
                : false,
            navigation: {
                nextEl: slideshow.querySelector('.swiper-button-next'),
                prevEl: slideshow.querySelector('.swiper-button-prev'),
            }
        });
    }
}
